import api, { paginado } from './apiClient'

// ---------------------------------------------------------------- Ordens ----

/** `GET /production-orders?subCompanyId&status&search&dateFrom&dateTo&limit&offset` */
export const getAllProductionOrders = async data => {
  const response = await api.get('/production-orders', {
    params: {
      subCompanyId: data.subCompanyId,
      status: data.status || undefined,
      search: data.search || undefined,
      dateFrom: data.dateFrom || undefined,
      dateTo: data.dateTo || undefined,
      limit: data.limit,
      offset: data.offset,
    },
  })
  return { data: paginado(response) }
}

export const getProductionOrdersByStatus = async data =>
  getAllProductionOrders({ ...data, status: data.status })

export const getProductionOrderId = async orderId => api.get(`/production-orders/${orderId}`)

/**
 * `GET /clients?subCompanyId&search` — cliente é escopado por FILIAL, não por
 * empresa como produto. Buscar sem filial devolve o que o usuário enxerga.
 */
export const searchClients = async ({ subCompanyId, search, limit = 20 }) => {
  const response = await api.get('/clients', {
    params: { subCompanyId, search: search || undefined, active: 'true', limit, offset: 0 },
  })
  return { data: paginado(response) }
}

export const createOrder = async data => api.post('/production-orders', data)

/** A criação da ordem já leva o fluxo e as quebras no mesmo POST. */
export const createOrderProcessFull = createOrder

export const editProductionOrder = async (orderId, data) =>
  api.patch(`/production-orders/${orderId}`, data)

/**
 * Cancelamento, não exclusão: o histórico de quebras é preservado.
 * `COMPLETO` e `CANCELADO` são terminais — transição inválida devolve 409.
 */
export const cancelProductionOrder = async orderId =>
  api.post(`/production-orders/${orderId}/cancel`)

export const deleteProductionOrder = cancelProductionOrder

// ---------------------------------------------------------------- Quebras ---

/** `GET /breaks?subCompanyId&orderId&status&search&dateFrom&dateTo&withStages&limit&offset` */
export const getAllBreaks = async data => {
  const response = await api.get('/breaks', {
    params: {
      subCompanyId: data.subCompanyId,
      orderId: data.orderId,
      status: data.status || undefined,
      search: data.search || undefined,
      dateFrom: data.dateFrom || undefined,
      dateTo: data.dateTo || undefined,
      withStages: data.withStages ? 'true' : undefined,
      limit: data.limit,
      offset: data.offset,
    },
  })
  return { data: paginado(response) }
}

/** `GET /production-orders/{id}/breaks` — devolve o array puro. */
export const getBreakList = async orderId => api.get(`/production-orders/${orderId}/breaks`)

/**
 * `POST /production-orders/{id}/breaks` — fraciona a ordem.
 *
 * A API divide o **saldo ainda não planejado**, não a quantidade total: chamar
 * duas vezes acrescenta quebras ao plano em vez de duplicá-lo. Saldo esgotado,
 * ordem encerrada ou `breakCount` maior que o saldo devolvem 409.
 */
export const splitOrderIntoBreaks = async (orderId, breakCount) =>
  api.post(`/production-orders/${orderId}/breaks`, { breakCount })

export const getBreak = async breakId => api.get(`/breaks/${breakId}`)

export const getBreakTimeline = async breakId => api.get(`/breaks/${breakId}/timeline`)

export const setBreakInProgress = async breakId => api.post(`/breaks/${breakId}/start`)

export const setBreakCompleted = async (breakId, data) =>
  api.post(`/breaks/${breakId}/complete`, data)

export const cancelBreak = async (breakId, data) => api.post(`/breaks/${breakId}/cancel`, data)

// ----------------------------------------------------------------- Kanban ---

/** `GET /production-orders/{id}/kanban` — `{ order, columns[] }`. */
export const getKanbanInfo = async orderId => api.get(`/production-orders/${orderId}/kanban`)
